"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
var react_1 = require("react");
var react_dom_1 = require("react-dom");
function Portal(props) {
    var children = props.children, container = props.container;
    var mountNode = react_1.useRef(typeof document !== 'undefined' ? document.body : null);
    react_1.useEffect(function () {
        mountNode.current = container || document.body;
        return function () {
            mountNode.current = null;
        };
    }, [container]);
    return mountNode.current ? react_dom_1.createPortal(children, mountNode.current) : null;
}
exports.Portal = Portal;
//# sourceMappingURL=Portal.js.map